module.exports = __webpack_public_path__ + "static/img/7.d5b5eff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/zh/7.png
// module id = WBZw
// module chunks = 0